
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator'
import Notifications from '@/components/Notifications/Notifications.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import Api from '@/models/Api'
import { betaUiUrl } from '@/helpers/beta'
import ViewModel from '../../models/ViewModel'

@Component({
  components: {
    Notifications,
  },
})
export default class Header extends ViewModel {
  public open_notifications: boolean = false

  // KAN-202 — invite beta-flagged users over to the new Foundry 2.0 UI.
  public get showBetaInvite(): boolean {
    return !!(this.user && this.user.beta)
  }

  public get betaUiUrl(): string {
    return betaUiUrl()
  }

  /* ---- First-visit beta invite modal (KAN-202) --------------------- */
  public showBetaModal: boolean = false

  private betaInviteChecked: boolean = false

  private readonly BETA_INVITE_COOKIE = 'foundry_beta_invite_seen'

  // The user object hydrates asynchronously (after /sync), so react to it
  // landing rather than relying on mounted(); the guard makes this run once.
  @Watch('user.id', { immediate: true })
  public onUserResolved() {
    this.maybeShowBetaInvite()
  }

  private maybeShowBetaInvite() {
    if (this.betaInviteChecked) return
    // Beta users only — the invite is to test the beta UI.
    if (!this.user || !this.user.id || !this.user.beta) return
    // Desktop only — don't surface it on phones/small tablets.
    if (typeof window !== 'undefined' && window.innerWidth < 992) return
    this.betaInviteChecked = true
    // Shown once: if the cookie is already set, never show again.
    if (this.getCookie(this.BETA_INVITE_COOKIE)) return
    this.setCookie(this.BETA_INVITE_COOKIE, '1', 365)
    this.showBetaModal = true
  }

  public openBeta() {
    window.location.href = this.betaUiUrl
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
    return match ? decodeURIComponent(match[1]) : null
  }

  private setCookie(name: string, value: string, days: number) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
  }

  public logout() {
    this.system.logout()
    // @ts-ignore
    if (window.google && window.google.accounts.id) {
      // @ts-ignore
      window.google.accounts.id.disableAutoSelect()
    }
  }

  public get notifications() {
    return getModule(SystemtModule).notifications.filter(
      (notification: any) => notification.read_at === null,
    ).length
  }

  public switchSidebarMethod() {
    if (!this.layout.sidebarClose) {
      this.layout.switchSidebar(true)
      this.layout.changeSidebarActive(null)
    } else {
      this.layout.switchSidebar(false)
      const paths = this.$route.fullPath.split('/')
      paths.pop()
      this.layout.changeSidebarActive(paths.join('/'))
    }
  }

  public toggleSidebarMethod() {
    if (this.layout.sidebarStatic) {
      this.layout.toggleSidebar()
      this.layout.changeSidebarActive(null)
    } else {
      this.layout.toggleSidebar()
      const paths = this.$route.fullPath.split('/')
      paths.pop()
      this.layout.changeSidebarActive(paths.join('/'))
    }
  }

  public markAsRead() {
    this.open_notifications = true
    const api = new Api(false)
    api.get('notifications/mark-as-read').then(() => {
      const system = getModule(SystemtModule)
      const notifications = system.notifications.map((notification: any) => {
        notification.read_at = true
        return notification
      })
      setTimeout(() => {
        system.updateState({
          name: 'notifications',
          data: notifications,
        })
      }, 5000)
    })
  }

  public myAccount() {
    this.$router.push('/app/account')
  }
}
